module.exports = __webpack_public_path__ + "media/images/logo-f1ddf9b1a811101b6156274159f84504.svg";